<template>
  <section>
    <template v-if="error === null">
      <preloader v-if="status === 'payment'" :isFetching="true" />
      <main class="fns-pay">
        <section v-if="isTokenExpired" class="fns-expired-token">
          <h1>
            Ваша ссылка устарела. Чтобы получить доступ к странице подтверждения сделки,
            нажмите на кнопку ниже и перейдите по ссылке из письма.
          </h1>

          <div class="fns-expired-token__button">
            <primary-button
              :loading="isSendingConfirmationLink"
              :disabled="!linkSent"
              @click="confirm"
            >
              Получить новый доступ
            </primary-button>
          </div>
        </section>
        <section v-if="!isTokenExpired">
          <section class="fns-pay-lang">
            <div class="fns-lang-selector" v-show="langSelectorVisible">
              <div v-for="l in langs" v-bind:key="l">
                <input
                  v-bind:id="'lang-' + l"
                  v-bind:value="l"
                  v-on:click="selectLang"
                  name="lang"
                  type="radio"
                />
                <label v-bind:for="'lang-' + l">{{ l }}</label>
              </div>
            </div>
            <div class="fns-selected-lang" v-on:click="toggleLangs">
              <span v-show="!langSelectorVisible">{{ lang }}</span>
            </div>
          </section>

          <h1>Подтверждение услуги</h1>

          <section class="fns-pay-info">
            <div class="fns-info-item">
              <div class="fns-info-item__name">№ Счета</div>
              <div class="fns-info-item__value">№{{ invoiceNumber }}</div>
            </div>
            <div class="fns-info-item">
              <div class="fns-info-item__name">Дата счета</div>
              <div
                class="fns-info-item__value"
                v-html="
                  $formatDate(date, {
                    year: 'numeric',
                    month: 'long',
                    day: '2-digit',
                  })
                "
              ></div>
            </div>
            <div class="fns-info-item">
              <div class="fns-info-item__name">Продавец</div>
              <div class="fns-info-item__value">
                {{ merchantName }}<br />
                ИНН {{ inn }}
              </div>
            </div>
            <div class="fns-info-item">
              <div class="fns-info-item__name">Товары, работы, услуги</div>
              <div class="fns-info-item__value">
                <ol>
                  <!-- <li>Макет – 1 500,00 ₽</li> -->
                  <li
                    class="fns-info-item__li"
                    v-for="p in saleInfo"
                    v-bind:key="p.productName"
                  >
                    {{ p.productName }} – <money :value="p.cost" />
                    <img src="~@/assets/img/mult.svg" />
                    {{ p.quantity }}
                  </li>
                </ol>
              </div>
            </div>
          </section>

          <section class="fns-pay-amount">
            <h2>Cумма к оплате</h2>
            <div class="fns-pay-amount__value"><money :value="totalAmount" /></div>
          </section>

          <section class="submit-container">
            <div class="fns-pay-contacts__desc">
              Нажимая кнопку “Услуга оказана”, вы подтверждаете факт выполнения услуги.
              Средства будут отправлены исполнителю.
            </div>

            <primary-button :loading="isLoadingConfirmServiceProvided" @click="confirm">
              Услуга оказана
            </primary-button>
          </section>
        </section>
      </main>
    </template>

    <template v-if="error !== null">
      <Fail :message="'Ошибка'" :desc="error" />
    </template>

    <v-snackbar v-model="isShowNotification" :timeout="2000">
      {{ notificationMessage }}
    </v-snackbar>
  </section>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'

import Fail from './Fail.vue'
import PrimaryButton from '@/components/PrimaryButton.vue'

export default {
  name: 'ServiceProvidedConfirmation',
  components: {
    Fail,
    PrimaryButton,
  },
  data() {
    return {
      token: null,
      langSelectorVisible: false,
      lang: 'RU',
      langs: ['GR', 'FR', 'EN', 'RU'],

      isTokenExpired: false,

      linkSent: false,

      isShowNotification: false,
      notificationMessage: '',
    }
  },

  computed: {
    ...mapState({
      saleInfo: (state) => state.pay.invoicePaymentData.saleInfo,
      merchantName: (state) => state.pay.invoicePaymentData.merchantName,
      invoiceNumber: (state) => state.pay.invoicePaymentData.invoiceNumber,
      inn: (state) => state.pay.invoicePaymentData.inn,
      date: (state) => state.pay.invoicePaymentData.date,
      totalAmount: (state) => state.pay.invoicePaymentData.totalAmount,

      isLoading: (state) => state.pay.isLoading,
      status: (state) => state.pay.invoicePaymentData.status,
      error: (state) => state.pay.error,

      isLoadingConfirmServiceProvided: (state) =>
        state.serviceProvidedConfirmation.isLoading,

      isSendingConfirmationLink: (state) =>
        state.serviceProvidedConfirmation.isSendingConfirmationLink,
    }),
    ...mapGetters({
      invoiceId: 'pay/invoiceId',
    }),
  },
  methods: {
    ...mapActions({
      requestPaySbp: 'pay/requestPaySbp',
      requestPaymentCard: 'pay/requestPaymentCard',
      enableSafeDeal: 'pay/enableSafeDeal',
      requestInvoicePaymentData: 'pay/requestInvoicePaymentData',
      confirmServiceProvided: 'serviceProvidedConfirmation/confirmServiceProvided',
      sendConfirmationLink: 'serviceProvidedConfirmation/sendConfirmationLink',
    }),
    ...mapMutations({ setEmail: 'pay/setEmail', setSuccess: 'pay/setSuccess' }),
    selectLang: function (event) {
      const lang = event.target.value
      this.toggleLangs()
      this.lang = lang
    },
    toggleLangs: function () {
      this.langSelectorVisible = !this.langSelectorVisible
    },

    async confirm() {
      const result = await this.confirmServiceProvided({
        invoiceInternalId: this.invoiceId,
        token: this.token,
      })

      if (result === 'success') {
        this.$router.push('/success-deal')
      } else {
        if (result.code === 'expired.token') {
          this.isTokenExpired = true
          return
        }

        this.notificationMessage = 'Ошибка при подтверждении услуги'
        this.isShowNotification = true
      }
    },

    async resendLink() {
      const result = await this.confirmServiceProvided({
        invoiceInternalId: this.invoiceId,
        token: this.token,
      })

      if (result) {
        this.linkSent = true
      }

      this.notificationMessage = result
        ? 'Ссылка для подтверждения отправлена'
        : 'Ошибка при отправке ссылки'
      this.isShowNotification = true
    },
  },
  mounted: function () {
    const invoiceId = this.$route.params.invoiceId
    const token = this.$route.query.token

    this.requestInvoicePaymentData({ invoiceId })

    this.token = token
  },
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500&display=swap');

@import './styles.scss';

.submit-container {
  display: flex;
  flex-direction: column;

  gap: 16px;

  margin-top: 20px;

  .fns-pay-contacts__desc {
    margin: 0;
    padding: 0;
  }
}

.fns-expired-token {
  height: 100vh;
  width: 100vw;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  gap: 24px;
  padding: 0 20px;

  h1 {
    font-weight: 400;
    font-style: Regular;
    font-size: 1.3rem;

    line-height: 140%;
    letter-spacing: 0.01em;

    color: #000000;

    margin: 0;
    padding: 0;
  }

  &__button {
    width: 100%;

    button {
      width: 100%;
    }
  }
}
</style>
